import React from "react";
import Layout from "./Layout";
import { useOtiService } from "./hooks/useOtiService";
import OtiContext from "./OtiContext";

export const UserApp = () => {
  const { openCookiePreferences } = useOtiService();

  return (
    <OtiContext.Provider value={{ openCookiePreferences }}>
      <Layout />
    </OtiContext.Provider>
  );
};
